import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#DDD",
      d: "M12 15.174c4.338 0 8 .705 8 3.425C20 21.319 16.315 22 12 22c-4.338 0-8-.705-8-3.425 0-2.72 3.685-3.401 8-3.401ZM11.999 2a5.273 5.273 0 0 1 5.294 5.291 5.274 5.274 0 0 1-5.294 5.292 5.275 5.275 0 0 1-5.294-5.292A5.274 5.274 0 0 1 12 2Z"
    }, null, -1)
  ]))]))
}
export default { render: render }